// import { useEffect, useState } from "react";
// import { auth, ref } from "../api/firebase";

export const useFlash = () => {
  const addTopic = (b) => console.dir(b);

  return {
    addTopic,
  };
};
